import Icon from '../components/icon';
import FilmIcon from '~icons/lucide/film';
import ExtractForm from '../components/extract-form';

<template>
  <div class="mx-auto max-w-3xl">
    <div class="mb-8">
      <h1 class="flex items-center gap-2 text-3xl font-bold">
        <Icon @icon={{FilmIcon}} class="h-8 w-8" />
        Extract Content
      </h1>
      <p class="text-base-content/70 mt-2">
        Submit a URL or upload an image to extract mentions of movies, TV shows,
        books, and more.
      </p>
    </div>

    <div class="card bg-base-100 shadow-xl" data-test-extract-panel>
      <div class="card-body">
        <ExtractForm />
      </div>
    </div>
  </div>
</template>
